import { FelaCSS } from '@bridebook/ui/src/components/fela/flowtypes';
import IconWrap from '@bridebook/ui/src/components/svg/icon-wrap';
import { IStylingProps } from '@bridebook/ui/src/themes/types';
import { TColor } from '@bridebook/ui/src/types';

interface IProps extends IStylingProps {
  id?: string;
  color?: TColor;
  width?: number;
  style?: FelaCSS;
}

interface IconTypes {
  iconColor: string;
  width: number;
  height: number;
}

const IconChecklistIllustration = ({ id, color, width = 161, style, ...restProps }: IProps) => {
  const viewBoxWidth = 161;
  const viewBoxHeight = 160;

  const icon = ({ width, height }: IconTypes) => (
    <svg
      id={id}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      fill="none"
      width={`${width}px`}
      height={`${height}px`}>
      <g clipPath="url(#clip0_2998_27620)">
        <path
          d="M77.0625 3.4375C34.7786 3.4375 0.5 37.7161 0.5 80C0.5 91.0754 2.85474 101.6 7.08691 111.105L55.7051 153.54C62.4849 155.505 69.6504 156.564 77.0637 156.564C119.348 156.564 153.626 122.285 153.626 80C153.626 37.7161 119.348 3.4375 77.0625 3.4375Z"
          fill="#4D52E3"
        />
        <path
          d="M120.997 149.119V115.178C120.997 112.649 118.947 110.6 116.418 110.6H31.5142C34.0422 110.6 36.0918 112.649 36.0918 115.178V144.686C42.2661 148.604 49.0386 151.666 56.2419 153.697H116.418C118.947 153.697 120.997 151.647 120.997 149.119Z"
          fill="#E8FFFA"
        />
        <path
          d="M53.72 149.119V115.178C53.72 112.649 55.7695 110.6 58.2988 110.6H31.5142C34.0422 110.6 36.0918 112.649 36.0918 115.178V144.686C42.2661 148.604 49.0386 151.666 56.2419 153.697H58.2988C55.7695 153.697 53.72 151.647 53.72 149.119Z"
          fill="#E8FFFA"
        />
        <path
          d="M47.372 130.431C45.9852 130.431 44.861 129.31 44.8573 127.923C44.8549 126.535 45.9779 125.407 47.3671 125.403L98.871 125.315H98.8759C100.263 125.315 101.387 126.437 101.391 127.824C101.393 129.213 100.27 130.341 98.882 130.344L47.3781 130.431C47.3756 130.431 47.3732 130.431 47.372 130.431Z"
          fill="#4D52E3"
        />
        <path
          d="M47.3943 141.074C46.0088 141.074 44.8833 139.952 44.8809 138.566C44.8772 137.178 46.0003 136.05 47.3894 136.046L89.5366 135.98H89.5427C90.9282 135.98 92.0537 137.102 92.0562 138.489C92.0598 139.877 90.9368 141.005 89.5476 141.008L47.4004 141.074H47.3943Z"
          fill="#4D52E3"
        />
        <path
          d="M136.172 58.452H51.2671C53.7952 58.452 55.8459 60.5016 55.8459 63.0297V96.9701C55.8459 99.4994 53.7952 101.549 51.2671 101.549H136.172C138.7 101.549 140.75 99.4994 140.75 96.9701V63.0297C140.75 60.5016 138.7 58.452 136.172 58.452Z"
          fill="#FFEDEC"
        />
        <path
          d="M73.4741 96.9701V63.0297C73.4741 60.5016 75.5237 58.452 78.0518 58.452H51.2671C53.7952 58.452 55.8459 60.5016 55.8459 63.0297V96.9701C55.8459 99.4982 53.7952 101.548 51.2671 101.548H78.0518C75.5237 101.548 73.4741 99.4994 73.4741 96.9701Z"
          fill="#FFEDEC"
        />
        <path
          d="M66.9993 78.2392C65.6138 78.2392 64.4883 77.1174 64.4858 75.7307C64.4822 74.3427 65.6052 73.2148 66.9944 73.2111L122.314 73.1147H122.32C123.706 73.1147 124.831 74.2365 124.835 75.6232C124.837 77.0124 123.714 78.1403 122.325 78.1428L67.0054 78.2392C67.0042 78.2392 67.0017 78.2392 66.9993 78.2392Z"
          fill="#4D52E3"
        />
        <path
          d="M109.163 88.8257H67.0156C65.6265 88.8257 64.501 87.7003 64.501 86.3111C64.501 84.9232 65.6265 83.7977 67.0156 83.7977H109.163C110.551 83.7977 111.676 84.9232 111.676 86.3111C111.676 87.7003 110.551 88.8257 109.163 88.8257Z"
          fill="#4D52E3"
        />
        <path
          d="M155.921 6.30505H71.0161C73.5454 6.30505 75.595 8.35461 75.595 10.8827V44.8231C75.595 47.3512 73.5454 49.402 71.0161 49.402H155.921C158.449 49.402 160.499 47.3512 160.499 44.8231V10.8827C160.499 8.35461 158.449 6.30505 155.921 6.30505Z"
          fill="#FCEED7"
        />
        <path
          d="M93.2231 44.8231V10.8827C93.2231 8.35461 95.2727 6.30505 97.8008 6.30505H71.0161C73.5442 6.30505 75.595 8.35461 75.595 10.8827V44.8231C75.595 47.3512 73.5442 49.402 71.0161 49.402H97.8008C95.2727 49.4008 93.2231 47.3512 93.2231 44.8231Z"
          fill="#FCEED7"
        />
        <path
          d="M76.6029 44.8226V10.8822C76.6029 8.35413 74.5533 6.30457 72.0253 6.30457H37.3195C34.7902 6.30457 32.7406 8.35413 32.7406 10.8822V44.8226C32.7406 47.3507 34.7914 49.4015 37.3195 49.4015H72.0253C74.5546 49.4003 76.6029 47.3507 76.6029 44.8226Z"
          fill="#F8D59C"
        />
        <path
          d="M52.0289 45.4489C52.0289 43.2137 53.7233 41.3741 55.8973 41.1447V14.6029C53.7233 14.3722 52.0289 12.5338 52.0289 10.2987C52.0289 8.49939 53.1263 6.95764 54.6876 6.30457H37.3182C34.7902 6.30457 32.7406 8.35413 32.7406 10.8822V44.8226C32.7406 47.3507 34.7902 49.4015 37.3182 49.4015H54.5961C53.0836 48.7252 52.0289 47.2115 52.0289 45.4489Z"
          fill="#F8D59C"
        />
        <path
          d="M66.5605 14.2939H42.5774C41.7119 14.2939 41.01 14.9958 41.01 15.8625V39.8445C41.01 40.7112 41.7119 41.4131 42.5774 41.4131H66.5605C67.426 41.4131 68.1279 40.7112 68.1279 39.8445V15.8625C68.1279 14.9958 67.426 14.2939 66.5605 14.2939Z"
          fill="#FCEED7"
        />
        <path
          d="M53.1646 39.8445V15.8625C53.1646 14.9958 53.8665 14.2939 54.7332 14.2939H42.5774C41.7119 14.2939 41.01 14.9958 41.01 15.8625V39.8445C41.01 40.7112 41.7119 41.4131 42.5774 41.4131H54.7332C53.8665 41.4131 53.1646 40.7112 53.1646 39.8445Z"
          fill="#FCEED7"
        />
        <path
          d="M86.6379 26.0482C85.2512 26.0482 84.127 24.9263 84.1233 23.5396C84.1209 22.1505 85.2439 21.0225 86.6318 21.0201L149.782 20.9066H149.787C151.175 20.9066 152.3 22.0284 152.303 23.4151C152.306 24.803 151.183 25.931 149.795 25.9346L86.644 26.0482C86.6428 26.0482 86.6392 26.0482 86.6379 26.0482Z"
          fill="#4D52E3"
        />
        <path
          d="M128.918 36.6776H86.7705C85.3813 36.6776 84.2559 35.5521 84.2559 34.1641C84.2559 32.7762 85.3813 31.6495 86.7705 31.6495H128.918C130.306 31.6495 131.431 32.7762 131.431 34.1641C131.431 35.5521 130.306 36.6776 128.918 36.6776Z"
          fill="#4D52E3"
        />
        <path
          d="M51.3359 32.9493L47.6091 29.2225C46.6277 28.2398 46.6277 26.648 47.6091 25.6666C48.5918 24.6839 50.1824 24.6839 51.165 25.6666L53.1145 27.616L57.9741 22.7564C58.9556 21.775 60.5474 21.775 61.53 22.7564C62.5115 23.7391 62.5115 25.3309 61.53 26.3123L54.8931 32.9493C53.9104 33.9307 52.3186 33.9307 51.3359 32.9493Z"
          fill="#4D52E3"
        />
        <path
          d="M56.8481 96.9701V63.0297C56.8481 60.5016 54.7986 58.452 52.2705 58.452H17.5635C15.0354 58.452 12.9858 60.5016 12.9858 63.0297V96.9701C12.9858 99.4994 15.0354 101.549 17.5635 101.549H52.2705C54.7986 101.548 56.8481 99.4982 56.8481 96.9701Z"
          fill="#FFA69E"
        />
        <path
          d="M32.2742 97.5963C32.2742 95.3612 33.9685 93.5228 36.1426 93.2921V66.7504C33.9685 66.5209 32.2742 64.6825 32.2742 62.4462C32.2742 60.6481 33.3716 59.1063 34.9329 58.452H17.5635C15.0354 58.452 12.9858 60.5016 12.9858 63.0297V96.9701C12.9858 99.4994 15.0354 101.549 17.5635 101.549H34.8401C33.3289 100.873 32.2742 99.359 32.2742 97.5963Z"
          fill="#FFA69E"
        />
        <path
          d="M46.8081 66.4418H22.825C21.9595 66.4418 21.2576 67.1437 21.2576 68.0092V91.9911C21.2576 92.8578 21.9595 93.5597 22.825 93.5597H46.8069C47.6736 93.5597 48.3755 92.8578 48.3755 91.9911V68.0092C48.3755 67.1437 47.6736 66.4418 46.8081 66.4418Z"
          fill="#FFEDEC"
        />
        <path
          d="M33.4121 91.9911V68.0092C33.4121 67.1437 34.114 66.4418 34.9795 66.4418H22.825C21.9595 66.4418 21.2576 67.1437 21.2576 68.0092V91.9911C21.2576 92.8578 21.9595 93.5597 22.825 93.5597H34.9795C34.114 93.5597 33.4121 92.8578 33.4121 91.9911Z"
          fill="#FFEDEC"
        />
        <path
          d="M31.5823 85.0961L27.8555 81.3693C26.8729 80.3867 26.8729 78.7949 27.8555 77.8134C28.837 76.8307 30.4288 76.8307 31.4114 77.8134L33.3597 79.7629L38.2193 74.9033C39.202 73.9218 40.7925 73.9218 41.7752 74.9033C42.7567 75.8859 42.7567 77.4777 41.7752 78.4592L35.1382 85.0961C34.1568 86.0776 32.5638 86.0776 31.5823 85.0961Z"
          fill="#4D52E3"
        />
        <path
          d="M32.5181 110.6H6.86499C13.1663 125.036 23.7864 137.151 37.0957 145.314V115.179C37.0957 112.649 35.0461 110.6 32.5181 110.6Z"
          fill="#B0E8DD"
        />
        <path
          d="M27.0566 118.589H10.9275C15.5564 126.506 21.5647 133.517 28.6252 139.292V120.157C28.6252 119.291 27.9233 118.589 27.0566 118.589Z"
          fill="#E8FFFA"
        />
      </g>
      <defs>
        <clipPath id="clip0_2998_27620">
          <rect width="160" height="160" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  );

  return (
    <IconWrap
      icon={icon}
      color={color}
      width={width}
      viewBoxWidth={viewBoxWidth}
      viewBoxHeight={viewBoxHeight}
      style={style}
      {...restProps}
    />
  );
};

export default IconChecklistIllustration;
